<div>
    <app-hero-section></app-hero-section>
    <app-dag-section></app-dag-section>
    <app-ecosystem-section></app-ecosystem-section>
    <app-how-it-works-section></app-how-it-works-section>
    <app-use-cases-section></app-use-cases-section>
</div>
